import React from "react";
import { Rocket } from "lucide-react";

const h2 = { margin: 0, fontSize: 22, fontWeight: 700, letterSpacing: "-0.02em", color: "#191c1d", fontFamily: "'Reckless Neue Variable', serif" };
const fmt = (iso) => new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });

export default function McpRoadmap({ catalog }) {
  const shipped = (catalog?.changelog || []).slice(0, 5);
  const roadmap = catalog?.roadmap || [];
  const col = { background: "#fff", border: "1px solid #e8ecee", borderRadius: 14, padding: 18 };
  return (
    <section id="roadmap" style={{ padding: "48px 24px" }}>
      <div style={{ maxWidth: 860, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 16 }}>
          <Rocket style={{ width: 18, height: 18, color: "#006874" }} />
          <h2 style={h2}>What&apos;s new &amp; roadmap</h2>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 14 }}>
          <div data-testid="mcp-shipped" style={{ ...col, borderTop: "3px solid #006874" }}>
            <p style={{ margin: 0, fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "#006874" }}>Shipped</p>
            <ul style={{ margin: "10px 0 0", padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 10 }}>
              {shipped.map((s) => (
                <li key={s.title} style={{ fontSize: 13, lineHeight: 1.55 }}>
                  <span style={{ color: "#6b7a7d", fontSize: 11, marginRight: 8 }}>{fmt(s.date)}</span><strong style={{ color: "#191c1d" }}>{s.title}</strong>
                  <div style={{ color: "#3b494c" }}>{s.text}</div>
                </li>
              ))}
            </ul>
          </div>
          <div data-testid="mcp-roadmap" style={{ ...col, borderTop: "3px solid #7c3aed" }}>
            <p style={{ margin: 0, fontSize: 11, fontWeight: 700, letterSpacing: "0.1em", textTransform: "uppercase", color: "#7c3aed" }}>Coming soon</p>
            <ul style={{ margin: "10px 0 0", padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 10 }}>
              {roadmap.map((r) => (
                <li key={r.title} style={{ fontSize: 13, lineHeight: 1.55 }}>
                  <strong style={{ color: "#191c1d" }}>{r.title}</strong>
                  {r.status === "in_progress" && <span style={{ marginLeft: 8, fontSize: 10, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: "#7c3aed", background: "#f3e8ff", borderRadius: 999, padding: "2px 8px" }}>in progress</span>}
                  <div style={{ color: "#3b494c" }}>{r.text}</div>
                </li>
              ))}
            </ul>
            <p style={{ margin: "12px 0 0", fontSize: 11, color: "#6b7a7d" }}>No dates are promised — join the notify list above to hear about ChatGPT support first.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
